import JQueryView from '../../../common/views/jqueryView';

export default class AppView extends JQueryView {
  constructor() {
    super('#sb-site');
    if (window.devicePixelRatio != null) {
      this.updateImages();
    }
  }

  updateImages() {
    const images = document.getElementsByTagName('img');

    for (const image of images) {
      if (!image.getAttribute('data-lazy-load')) {
        this.refreshImage(image);
      }
    }
  }

  refreshImage(image: HTMLImageElement) {
    const lazyLoad = image.getAttribute('data-lazy-load');
    const imageSrc = image.src;
    const hiDpiSrc = image.getAttribute('data-hidpi-src');
    const lowDpiSrc = image.getAttribute('data-lowdpi-src');

    if (!hiDpiSrc) {
      return;
    }

    if (lazyLoad) {
      image.removeAttribute('data-lazy-load');
    }

    if (window.devicePixelRatio > 1 && imageSrc != hiDpiSrc) {
      if (!lowDpiSrc) {
        image.setAttribute('data-lowdpi-src', imageSrc);
      }
      image.src = hiDpiSrc;
    } else if (
      lowDpiSrc != null &&
      (!window.devicePixelRatio || window.devicePixelRatio <= 1) &&
      (imageSrc == hiDpiSrc || (lowDpiSrc && imageSrc != lowDpiSrc))
    ) {
      image.src = lowDpiSrc;
    }
  }
}
